<template>
    <v-card class="interface-mail-mail">
        <v-card-title class="theme">
            <h2>Тема: {{theme}}</h2>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-title>
            <v-list-tile-avatar>
                <img :src="avatar">
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title>{{from}}</v-list-tile-title>
                <!--<v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>-->
            </v-list-tile-content>
            
        </v-card-title>
        <v-divider></v-divider>
        <v-container v-html="message"></v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'interface-mail-mail',
        props: {
            id: [String, Number],
            from: String,
            theme: String,
            time: String,
            message: String,
        },
        components: {},
        computed: {
            avatar () {
                return `https://placeimg.com/40/40/tech/${this.id}`
            }
        }
    }
</script>

<style scoped lang="stylus">
    .interface-mail-mail {
        margin-top 15px
    }
</style>
